export default __webpack_public_path__ + "static/Large_Metal_Wall-7d943bc31f6b696a6927455b3b8e8748.png";